import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import * as Fields from 'support/fields'
import * as UI from 'ui'
import { Fieldset } from 'layouts'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import UpdateModelOnChange from 'support/utilities/UpdateModelOnChange'
import { WhenModelValue } from '@morningtrain/react-resources'
import * as Displays from 'support/displays'
import { Env } from '@morningtrain/helpers'

export default function EmploymentInformationFieldset ({ create = false }) {
  const hasWaiter = Env.get('globals.has_waiter');
  const hasKitchen = Env.get('globals.has_kitchen');
  const hasFirm = Env.get('globals.has_firm');

  return (
    <UI.CardWithHeader header={<Translation name='headers.employment_information' />}>

      <Fieldset>
        <Fieldset cols={2}>
          <Can permission={Permissions.EMPLOYMENTS_MANAGE_USERS_FULL}>
            <Fields.Date
              name='hired_at'
              label={<Translation name='fields.hired_at.label' />}
            />
          </Can>
          <Can permission={Permissions.EMPLOYMENTS_MANAGE_USERS_FULL} negate>
            <Fields.Display
              name='hired_at'
              type={Displays.Date}
              label={<Translation name='fields.hired_at.label' />}
            />
          </Can>

          <Fieldset cols={2}>
            <Fields.TabsField
              name="work_type"
              enum="work_type"
              defaultValue="fulltime"
              readOnly
              label={<Translation name="fields.work_type.label"/>}
            />

            <Fields.TabsField
              name='tax_type'
              enum='tax_type'
              defaultValue='primary'
              label={<Translation name='fields.tax_type.label' />}
            />
          </Fieldset>

          <Fields.Number
            name='weekly_hours'
            min={0}
            step={0.1}
            defaultValue={37.5}
            readOnly
            label={<Translation name="fields.weekly_hours.label"/>}
          />

          <Fields.Input
            name='staff_card_id'
            label={<Translation name='fields.staff_card_id.label' />}
          />

          <Fields.DepartmentsField
            name='department_ids'
            label={<Translation name='fields.departments.label' />}
            multiple
          />

          {
            hasFirm ?
              <Fields.FirmsField
                name='firm_ids'
                label={<Translation name='fields.firms.label' />}
                multiple
              />
              : false
          }

        </Fieldset>

        <Fieldset cols={2}>
          {hasWaiter ?
            <Fields.TabsField
              name='is_schedule_waiter'
              enum='boolean_status'
              defaultValue={0}
              label={<Translation name='fields.is_schedule_waiter.label' />}
            /> : hasWaiter
          }

          {hasKitchen ?
            <Fields.TabsField
              name='is_schedule_kitchen'
              enum='boolean_status'
              defaultValue={0}
              label={<Translation name='fields.is_schedule_kitchen.label' />}
            /> : hasKitchen
          }

          <Fields.TabsField
            name='is_schedule_cleaning'
            enum='boolean_status'
            defaultValue={0}
            label={<Translation name='fields.is_schedule_cleaning.label' />}
          />

          <Fields.TabsField
            name='exclude_in_schedule_planner'
            enum='boolean_status'
            defaultValue={0}
            label={<Translation name='fields.exclude_in_schedule_planner.label' />}
          />

          <UpdateModelOnChange name='time_limit_period'>
            <Fields.Select
              name='time_limit_period'
              enum='time_limit_period'
              label={<Translation name='fields.time_limit_period.label' />}
            />
          </UpdateModelOnChange>
          <WhenModelValue name='time_limit_period' condition='weekly'>
            <Fields.Number
              name='time_limit_amount'
              label={<Translation name='fields.time_limit_amount.label' />}
            />
          </WhenModelValue>
          <Can permission={Permissions.EMPLOYMENTS_MANAGE_USERS_FULL}>
            <Fields.TabsField
              name='is_in_food_arrangement'
              enum='boolean_status'
              defaultValue={1}
              label={<Translation name='fields.is_in_food_arrangement.label' />}
            />
          </Can>

        </Fieldset>

      </Fieldset>

    </UI.CardWithHeader>
  )
}
